export interface SocialErrorCopy {
  info: string;
  message: string;
}

const CANCEL_CODES = new Set([
  'popup_closed_by_user',
  'popup_closed',
  'user_cancelled',
  'user_canceled',
  'cancelled',
  'canceled',
]);

const MESSAGES: Record<string, SocialErrorCopy> = {
  social_email_not_verified: {
    info: 'This email address is not verified.',
    message:
      'Please sign in to your account using the email and password and request a verification email to your inbox.',
  },
  social_is_already_connected: {
    info: 'Another account already exists.',
    message:
      'Your Google or Apple email address is already associated with another Finder account. Please log in to that account and delete it before linking your Google or Apple account.',
  },
  sso_email_not_the_same_as_user_email: {
    info: 'The email address on your Finder account doesn’t match your Google or Apple account.',
    message: 'You must use the same email address to link your Google or Apple account.',
  },
  base_email_not_verified: {
    info: 'This email address is not verified.',
    message:
      'Please sign in with your password, go to your Finder dashboard and verify your email to be able to sign in with your social account.',
  },
  other_account_with_email_exist: {
    info: 'This email address is assigned to an existing account but isn’t a primary sign-in method.',
    message:
      'Please sign in using your phone number. Then contact us using the chat to set up your email address as the primary authentication method.',
  },
  already_connected_for_current_region: {
    info: 'Your Google or Apple account has been linked to a Finder account in current country.',
    message:
      'Your Finder account has been linked to Google or Apple account already. You are allowed to link only one.',
  },
  sso_connected_in_different_region: {
    info: 'Your Google or Apple account has been linked to a Finder account in another country.',
    message: 'Switch country using the main navigation to your usual one and try logging in again.',
  },
  google_already_connected: {
    info: 'You cannot link another Google account.',
    message:
      'Your Finder account has been linked to another Google account already. You are allowed to link only one.',
  },
  maintenance_mode: {
    info: 'We are currently performing scheduled system maintenance, please try again later.',
    message: '',
  },
  user_account_is_blocked: {
    info: 'Something went wrong, please try again later. Otherwise please contact customer services.',
    message: '',
  },
  cookies_not_available: {
    info: 'Your browser has cookies disabled, which we use to log you in securely. Enable cookies in your browser settings and try again, or contact us if the issue persists.',
    message: '',
  },
  iframe_loading_error: {
    info: 'Something unexpected went wrong and we’re looking into it.',
    message: 'Please click the button below to try again.',
  },
  user_exists: {
    info: 'You already have a Finder account.',
    message: 'It looks like you’ve signed up before. Please sign in to access your account.',
  },
  popup_blocked: {
    info: 'Your browser blocked the sign-in window.',
    message:
      'Allow pop-ups for finder.com.au and try again, or continue with email below.',
  },
};

const DEFAULT_COPY: SocialErrorCopy = {
  info: 'Something unexpected went wrong and we’re looking into it.',
  message:
    'Please come back and try again in a few minutes or contact us using live chat if you have an urgent query.',
};

export function socialErrorCopy(code: string): SocialErrorCopy | null {
  const normalised = code.trim().toLowerCase();
  if (CANCEL_CODES.has(normalised)) return null;
  return MESSAGES[normalised] ?? DEFAULT_COPY;
}
